<template>
    <ion-row v-if="hasVariants && availableProducts.length">
        <ion-col>
            <select-variant
                v-model="product"
                :options="availableProducts"
                @change="setStartAmount"
            />
        </ion-col>
    </ion-row>

    <ion-row class="mt-3 max-width" v-if="availableProducts.length">
        <ion-col size="12">
            <input-amount
                v-model.number="amount"
                :amount-step="product?.stepAmount ?? 1"
                :max="product?.limitOrderSize"
                :min-value="product?.stepAmount ?? 1"
                :direct-input-disabled="Number(product?.stepAmount) > 1"
            />
        </ion-col>
    </ion-row>


    <ion-row v-if="availableProducts.length">
        <ion-col class="center">
            <button-base
                :color="ION_VARIANT.CORAL"
                class="ml-3 mr-3 fw-b wrap-button tt-none max-width"
                @click="$emit('add')"
                :disabled="!amount"
            >
                {{ $t(`modal.${cart ? 'addCart' : 'addList'}`) }}
            </button-base>
        </ion-col>
    </ion-row>
</template>

<script setup lang="ts">
import { IonCol, IonRow } from "@ionic/vue";
import { computed } from "vue";

import ButtonBase from "@/components/button/ButtonBase.vue";
import InputAmount from "@/components/input/InputAmount.vue";
import SelectVariant from "@/components/selects/SelectVariant.vue";

import { ION_VARIANT } from "@/types/enum/ionicEnum";
import { INFORMATION_TYPE } from "@/types/enum/notification";
import { NewsModalProductInterfaceProps } from "@/types/props/component";
import { NewsModalProductInterfaceEmits } from "@/types/emits/component";
import { ProductMaster } from "@/types/supplier";
import { useLocationStore } from "@/stores/locations";
import { useSupplierStore } from "@/stores/suppliers";

const props = defineProps<NewsModalProductInterfaceProps>()
const emit = defineEmits<NewsModalProductInterfaceEmits>()

const supplierStore = useSupplierStore()

const amount = computed<number>({
    get: () => {
        return props.amount
    },
    set: (value) => {
        emit('update:amount', value)
    }
})

const product = computed<ProductMaster>({
    get: () => {
        return props.modelValue
    },
    set: (value) => {
        emit('update:modelValue', value)
    }
})

const hasVariants = computed<boolean>(() => (props.information.kind === INFORMATION_TYPE.PRODUCT_PRESENTATION || props.information.kind === INFORMATION_TYPE.PROMOTION)
    && props.information?.products.length > 0
)

const availableProducts = computed(() => {
    const matchedProducts = []
    for (const product of props.information.products) {
        if (product.availableBy?.length) matchedProducts.push(product)
    }
    if (!matchedProducts.length && props.cart) return props.information.products
    return matchedProducts
})

const adjustStep = (stepAmount: number | undefined, amount: number): number => {
    if (!stepAmount || (amount % stepAmount == 0)) return amount

    const offset = amount % stepAmount
    return amount -= offset
}

const setStartAmount = (product: ProductMaster): void => {
    if (product.recommendedAmount) {
        amount.value = product.recommendedAmount
        return
    }

    if (product.limitOrderSize && amount.value > product.limitOrderSize) {
        const newSize = product.limitOrderSize
        amount.value = adjustStep(product.stepAmount, newSize) //Enforce limitOrderSize multiple of stepSize in controller?
        return
    }

    // amount.value = adjustStep(product.stepAmount, amount.value)
    amount.value = product.stepAmount || 1
}
</script>

<style scoped>

</style>
